import Flag from "react-country-flag";
import Icon from "../../Icon";
import styles from "../Menu.module.css";
import PrimeTooltip from "../../PrimeTooltip/PrimeTooltip";

export interface PopupContextMenuLinkButtonProps {
  id?: string;
  text: any;
  icon?: string;
  flag?: string;
  onClick?: (e?: Event) => void;
  disabled?: boolean;
  withTooltip?: boolean;
  dataCy?: string;
  role?: string;
  tabIndex?: number;
}

export const PopupContextMenuLinkButton = ({
  id,
  text,
  icon = undefined,
  flag = undefined,
  onClick = undefined,
  disabled = false,
  withTooltip,
  dataCy,
  role,
  tabIndex,
}: PopupContextMenuLinkButtonProps) => (
  <>
    {withTooltip && <PrimeTooltip target={`#${id}`} />}
    <button
      id={id}
      data-cy={dataCy}
      data-pr-tooltip={text}
      type="button"
      className={styles.popupContextMenuLinkButton}
      onClick={() => onClick && onClick()}
      disabled={disabled}
      role={role}
      tabIndex={tabIndex}
    >
      {icon && <Icon name={icon} size={16} color="Grey-400" />}
      {!flag && !icon && (
        <span className={styles.popupContextMenuLinkButtonIcon} />
      )}
      {flag ? (
        <Flag
          svg
          countryCode={flag}
          className={styles.dropdownFlag}
          aria-label="language"
        />
      ) : null}
      <span className={styles.popupContextMenuLinkButtonText}>{text}</span>
    </button>
  </>
);
